import { Link } from 'react-router-dom';
import type { Recipe } from '../data/recipes';
import { RecipeIllustration } from './RecipeIllustration';

type RecipeCardProps = {
  recipe: Recipe;
};

/** One recipe in the grid: cover art, title, tagline, and quick facts. */
export function RecipeCard({ recipe }: RecipeCardProps) {
  const totalMinutes = recipe.prepMinutes + recipe.cookMinutes;

  return (
    <article className="group relative overflow-hidden rounded-2xl bg-white shadow-gloss transition-shadow duration-200 focus-within:ring-4 focus-within:ring-plume-300 hover:shadow-gloss-lg">
      <RecipeIllustration
        accent={recipe.accent}
        variant={recipe.variant}
        className="aspect-[5/3] w-full"
      />
      <div className="relative p-5">
        <h3 className="font-display text-xl text-plume-950">
          <Link
            to={`/recipes/${recipe.slug}`}
            className="after:absolute after:inset-0 after:content-[''] focus:outline-none"
          >
            {recipe.title}
          </Link>
        </h3>
        <p className="mt-1 text-sm italic text-bronze-700">{recipe.tagline}</p>
        <dl className="mt-4 flex flex-wrap gap-x-5 gap-y-1 text-sm text-plume-700">
          <div className="flex gap-1.5">
            <dt className="font-semibold">Time:</dt>
            <dd>{totalMinutes} min</dd>
          </div>
          <div className="flex gap-1.5">
            <dt className="font-semibold">Serves:</dt>
            <dd>{recipe.servings}</dd>
          </div>
          <div className="flex gap-1.5">
            <dt className="font-semibold">Effort:</dt>
            <dd>{recipe.difficulty}</dd>
          </div>
        </dl>
      </div>
    </article>
  );
}
